import type { HandoverAccount } from './identity-custody/delivery-client';
import type { CourierDeliveryReview } from './courier-delivery';
export async function loadCourierDeliveryReview(base: string, account: HandoverAccount, shipmentId: string, current: () => boolean): Promise<CourierDeliveryReview> {
  if (!current()) throw new Error('Return to the original company and shipment.');
  const response = await fetch(`${base}/api/shipments/${encodeURIComponent(shipmentId)}/courier/delivery-review`, {
    credentials:'include', cache:'no-store', headers:{'X-Shop-Domain':account.domain,...(account.organizationId?{'X-Organization-Id':account.organizationId}:{})},
  });
  const data = await response.json().catch(() => null);
  if (!current()) throw new Error('The account or company changed.');
  if (!response.ok || data?.success !== true) throw new Error(data?.error || 'Could not read courier delivery evidence.');
  const r = data.review;
  if (r?.shipment_id !== shipmentId || !/^[a-f0-9]{64}$/.test(r.digest) || !Array.isArray(r.parcels) || !Array.isArray(r.blockers)) throw new Error('The courier delivery review could not be confirmed.');
  return r;
}
